/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'stop': {
    width: 16,
    height: 16,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M703.147 668.16a35.84 35.84 0 11-72.107 0V355.84a35.84 35.84 0 1172.107 0zm-310.187 0a35.84 35.84 0 11-72.107 0V355.84a35.84 35.84 0 1172.107 0zM512 0a512 512 0 10512 512A512 512 0 00512 0z"/>'
  }
})
